import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const TilesGrid = styled.div`
  display: grid;
  gap: ${Spacing.S8};
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
`
